<script lang="ts">
    import { onMount } from "svelte";
    import { Router, Route, navigate } from "svelte-navigator";
    import { loader, modal, oidcToken, swClient, user } from "../stores";

    import AdminHeader from "./AdminHeader.svelte";
    import Home from "../Home.svelte";
    import Modal from "svelte-simple-modal";
    import AdminHome from "./AdminHome.svelte";
    import BrandDashboard from "./BrandDashboard.svelte";

    let me = null;

    onMount(async () => {
        const processId = $loader.show("Chargement");

        $swClient.getMe().then(
            (result) => {
                $user.setUser(result);
                me = result;
                $loader.hide(processId);
            },
            (err) => {
                console.error(err);
                if (err.status === 401) {
                    localStorage.removeItem("onecatalog-admin-token");
                    oidcToken.set(undefined);
                    navigate("/login");
                }
                $loader.hide(processId);
            }
        );
    });
</script>

<Router>
    <div id="main-content">
        {#if me !== null}
            <Modal show={$modal} closeButton="true">
                <Route path="/catalog/:catalog/:shop/*" component={Home} />
                <Route
                    path="/brand-dashboard/:operationCode"
                    component={BrandDashboard}
                />
                <Route>
                    <AdminHeader />
                    <AdminHome />
                </Route>
            </Modal>
        {:else}
            <p class="no-user">
                Utilisateur non reconnu <br />
                S'il s'agit de votre première connexion, veuillez ré-actualiser cette
                page d'ici quelques minutes <br />
                Merci pour votre compréhension
            </p>
        {/if}
    </div>
</Router>

<style lang="scss">
    @import "../styles/variables.scss";
    #main-content {
        background-color: white;
        height: 100%;
        overflow: auto;
        .no-user {
            text-align: center;
            font-size: 1.6em;
            margin: auto;
            margin-top: 20%;
        }
    }
</style>
